<template>
  <div class="container">
    <template v-if="ready">
      <div class="post-container">
        <PostPreview
          :post="post"
          v-for="(post, index) in currentPosts"
          :key="post.id"
          :num="index + 1"
        />
      </div>
      <div id="buttons">
        <button
          id="prev"
          @click="prevPage"
          v-if="minPost !== 0"
        >
          Previous Page
        </button>
        <button
          id="next"
          @click="nextPage"
          v-if="endPost < postIds.length"
        >
          Next Page
        </button>
      </div>
    </template>
    <template v-else-if="error">
      <div class="post-container">
        <h3>There was an error loading this page. Try reloading.</h3>
      </div>
    </template>
    <template v-else>
      <div class="post-container">
      </div>
    </template>
  </div>
</template>

<script>
import PostPreview from '@/components/PostPreview'
import { mapActions, mapGetters, mapMutations } from 'vuex'

const postsPerPage = 15
export default {
  name: 'PostList',
  components: { PostPreview },
  data () {
    return {
      postIds: null,
      ready: false,
      error: null,
      page: this.getPage(this.$route)
    }
  },
  props: {
    source: String
  },
  watch: {
    async $route (newRoute) {
      this.page = this.getPage(newRoute)
      this.setListPageUri(location.href)
      await this.updatePosts(this.postIds)
    }
  },
  methods: {
    ...mapActions(['updateItem']),
    ...mapMutations(['setListPageUri']),
    nextPage () {
      this.$router.push({
        query: {
          p: (this.page + 1).toString()
        }
      })
      window.scroll({
        top: 0
      })
    },
    prevPage () {
      this.$router.push({
        query: {
          p: (this.page - 1).toString()
        }
      })
    },
    async updatePosts (postIds) {
      const reqs = []
      for (let i = this.minPost; i < this.endPost; i++) {
        reqs[i] = this.updateItem(postIds[i])
      }
      this.ready = true
      return await Promise.all(reqs)
    },
    getPage (route) {
      let page = 1
      if (route.query.p) {
        page = parseInt(route.query.p, 10)
      }
      if (!page || page <= 0) {
        page = 1
      }

      return page
    },
    async handleKey (event) {
      let num
      try {
        num = parseInt(event.key, 16)
        const index = this.minPost + num - 1
        if (this.postIds.length > index) {
          await this.$router.push(`/post/${this.postIds[index]}`)
        }
      } catch (e) { }
    }
  },
  async created () {
    this.setListPageUri(location.href)
    window.addEventListener('keyup', this.handleKey)

    try {
      const topResp = await fetch(this.source)
      const postIds = await topResp.json()

      this.postIds = postIds
      const fetchPosts = this.updatePosts(postIds)
      await fetchPosts
    } catch (e) {
      this.error = e
    }
  },

  destroyed () {
    window.removeEventListener('keyup', this.handleKey)
  },
  computed: {
    ...mapGetters(['items']),
    minPost () {
      const val = postsPerPage * (this.page - 1)
      if (this.postIds) {
        return Math.min(val, this.postIds.length)
      } else {
        return val
      }
    },
    endPost () {
      const val = this.minPost + postsPerPage
      if (this.postIds) {
        return Math.min(val, this.postIds.length)
      } else {
        return val
      }
    },
    currentPosts () {
      if (!this.postIds) return null
      return this.postIds
        .slice(this.minPost, this.endPost)
        .map(id => this.items[id])
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme";

.post-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container {
  background-color: whitesmoke;
  min-height: calc(100vh - #{$navBarHeight});
  display: flex;
  flex-direction: column;
}

#buttons {
  margin: 20px 0;
  text-align: center;
}

#prev, #next {
  background-color: $default-background;
  color: white;
  border: none;
  border-radius: 3px;
  margin: 5px;
  padding: 6px 11px;
  font-size: 18px;

  &:hover {
    cursor: pointer;
  }

  &:active {
    background-color: $click-background;
  }
}

@media (min-width: $big-min) {
  .post-container {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 85%;
    align-self: center;
  }

}
</style>
